import { callEndpoint } from '../backend';

export const setUserTagsInRegionUnavailable = async ({
  email,
  volunteering,
  country,
}) => {
  const setUserTagsInRegionUnavailableResponse = await callEndpoint(
    callEndpoint.endpoints.setUserTagsInRegionUnavailable,
    {
      email,
      volunteering,
      country,
    },
  );

  return setUserTagsInRegionUnavailableResponse;
};

export const initialize = () => {};
